import { createAction } from 'redux-actions';

import types from './types';

const STORE_SELECTED = createAction(types.STORE_SELECTED);
const loginDone = createAction(types.LOGIN_DONE);
const setLoading = createAction(types.SET_LOADING);
const doLogout = createAction(types.DO_LOGOUT);
const afterLogout = createAction(types.AFTER_LOGOUT);
const doLogin = createAction(types.DO_LOGIN);
const setError = createAction(types.SET_ERROR);
const socialRegistration = createAction(types.SOCIAL_REGISTRATION);
const _setDataField = createAction(types.SET_DATA_FIELD);
const setDataField = (name, value) => _setDataField({ name, value });
const _initializeDataField = createAction(types.INITIALIZE_DATA_FIELD);
const initializeDataField = (username, password, rememberMe) =>
    _initializeDataField({ username, password, rememberMe });
const store = createAction(types.STORE);
const checkUserToken = createAction(types.CHECK_USER_TOKEN);
const setStopErrorResetPropagation = createAction(types.SET_STOP_ERROR_RESET_PROPAGATION);
const resetPassword = createAction(types.RESET_PASSWORD);
const setLoginPopoverName = createAction(types.SET_LOGIN_POPOVER_NAME);
const loginProfileReady = createAction(types.LOGIN_PROFILE_READY);
const setFocused = createAction(types.SET_FOCUSED);
const setUnfocused = createAction(types.SET_UNFOCUSED);
const setFbAppId = createAction(types.SET_FB_APP_ID);

export default {
    afterLogout,
    checkUserToken,
    doLogin,
    doLogout,
    initializeDataField,
    loginDone,
    loginProfileReady,
    resetPassword,
    setDataField,
    setError,
    setLoading,
    setLoginPopoverName,
    setStopErrorResetPropagation,
    socialRegistration,
    STORE_SELECTED,
    store,
    setFocused,
    setUnfocused,
    setFbAppId,
};
